<template>
  <div class="container">
    <div v-if="hasErrors" class="error-messages">
      <ul>
        <li v-for="error in errors" :key="error.code">
          {{ error.message }}
        </li>
      </ul>
    </div>
    <form class="form" @submit.prevent="handleRecoverySubmit">
      <label class="field">
        <div class="input">
          <input
            v-model.trim="email"
            type="email"
            class="input__element"
            autocomplete="email"
            placeholder="E-mail address"
          />
          <div v-if="v$.email.$dirty" class="input__response">
            <ul>
              <li v-for="error of v$.email.$errors" :key="error.$uid">
                {{ error.$message }}
              </li>
            </ul>
          </div>
        </div>
      </label>
      <div class="field">
        <Button type="submit" full-width>Reset</Button>
      </div>
    </form>

    <div v-if="success" class="input form__response">
      <div class="input__response input__response--success">
        You'll receive recovery email shortly with instructions on how to reset
        your password.
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import accountRecoveryMutation from "@/graphql/mutations/AccountRecovery.gql";
import Button from "@/components/Button.vue";

export default {
  name: "AccountRecovery",
  components: {
    Button,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      email: null,
      errors: [],
      success: false,
    };
  },
  computed: {
    hasErrors() {
      return this.errors.length > 0;
    },
  },
  methods: {
    async handleRecoverySubmit() {
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }

      const { data } = await this.$apollo.mutate({
        mutation: accountRecoveryMutation,
        variables: {
          email: this.email,
        },
      });

      const errors = data?.customerRecover?.customerUserErrors;
      if (errors.length > 0) {
        this.success = false;
        this.errors = errors;
      } else {
        this.success = true;
        this.errors = [];
      }
    },
  },
  validations() {
    return {
      email: { required, email },
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form.scss";

.error-messages {
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: $color-red;
  padding: 16px;
  color: $color-white;
  border-radius: 2px;
  font-size: 10px;
}
</style>
